/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    export class SettingsLoanerAgreementSummaryController {

        public static $inject : string[ ] = [

        ];

        public modal: any;

        constructor(

        ) {
            var that = this;
        }
    }

    getDealerwareWebContentModule().controller(
        'SettingsLoanerAgreementSummaryController', SettingsLoanerAgreementSummaryController
    );


    export class SettingsLoanerAgreementSummaryService {

        constructor(
            public $q                               : ng.IQService,
            public DealerwareLoanerAgreementModel   : any
        ) {

        }

        public deleteBullet (locationId : string, id : number) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            this.DealerwareLoanerAgreementModel.deleteBullet ({
                params: {
                    location_id     : locationId,
                    id              : id
                },
                promise: true
            })
                .then( ( response : any ) => {
                    defer.resolve (response.data);
                })
                .catch( ( response : any ) => {
                    defer.reject (response);
                });

            return defer.promise;
        }

        public saveBullets (locationId: string, bullets: any) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            var bulletsToSave = bullets.map( ( bullet : any ) => {
                return {
                    id                  : bullet.id,
                    text                : bullet.text,

                    // Add sort order to new bullets.
                    //
                    numeric_order       : bullet.sortOrderIndex
                }
            });

            this.DealerwareLoanerAgreementModel.saveBullets ({
                params: {
                    location_id         : locationId,
                },
                data: {
                    agreement_toggles   : bulletsToSave
                },
                promise: true
            })
                .then( ( response : any ) => {
                    defer.resolve (response.data);
                })
                .catch( ( response : any ) => {
                    defer.reject (response);
                });


            return defer.promise;
        }

        public getBullets (locationId : string) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            this.DealerwareLoanerAgreementModel.getBullets({
                params: {
                    location_id: locationId
                },
                promise: true
            })
                .then( ( response : any ) => {
                    defer.resolve (response.data);
                })
                .catch( ( response : any ) => {
                    defer.reject (response);
                });

            return defer.promise;
        }
    }

    getDealerwareWebContentModule().factory('SettingsLoanerAgreementSummaryService', (
        $q                              : any,
        DealerwareLoanerAgreementModel  : any
    ) => new SettingsLoanerAgreementSummaryService($q, DealerwareLoanerAgreementModel));

}
